module.exports = __webpack_public_path__ + "img/dynamic-tariff.0e8f32c7.png";